function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoBook = function SvgNoBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122 121"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54028"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25949",
    d: "m14942.735 1990.707 50.3 23.735v55.021l-50.3-18.448z",
    transform: "translate(-14929.186 -1949.463)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      strokeLinecap: "round",
      stroke: "#858baf",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25950",
    d: "M15022.13 1992.854v48.963l-43.328 26.632-1.026-54.617z",
    transform: "translate(-14915.286 -1948.546)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#858baf",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25951",
    d: "m14973.895 1984.747 13.5-22.116 50.561 16.207-14.164 26.97z",
    transform: "translate(-14916.952 -1961.631)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#858baf",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25952",
    d: "m14942.735 1995.332 43.984-16.778 49.118 20.39-43.48 20.831z",
    transform: "translate(-14929.186 -1954.781)",
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#858baf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25953",
    d: "m14996.664 2022.793-12.09-34.64-49.625-18.469 11.479 30.116z",
    transform: "translate(-14933.949 -1958.62)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#858baf",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25954",
    d: "m14953.664 2001.2 21.053 7.43v8.323l-21.053-6.9z",
    transform: "translate(-14926.232 -1945.071)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 2,
      stroke: "#858baf",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1045",
    transform: "translate(66.883 63.778)",
    style: {
      strokeDasharray: "2 3",
      fill: "none",
      strokeLinecap: "round",
      stroke: "#858baf"
    },
    d: "M0 0v53.575"
  })));
};

export default SvgNoBook;